module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DropdownSelect', {
    attrs: {
      "options": _vm.options,
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07783fb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/dropdown-select.vue
// module id = 1969
// module chunks = 2